import { render, staticRenderFns } from "./MintTube.vue?vue&type=template&id=6cdc8c48&scoped=true&"
import script from "./MintTube.vue?vue&type=script&lang=js&"
export * from "./MintTube.vue?vue&type=script&lang=js&"
import style0 from "./MintTube.vue?vue&type=style&index=0&id=6cdc8c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc8c48",
  null
  
)

export default component.exports